define( function() {
	return window.document;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/document.js
 ** module id = 822
 ** module chunks = 2
 **/